import { render, staticRenderFns } from "./ModalCreateResponsible.vue?vue&type=template&id=9f3a28e6&scoped=true"
import script from "./ModalCreateResponsible.vue?vue&type=script&lang=js"
export * from "./ModalCreateResponsible.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateResponsible.vue?vue&type=style&index=0&id=9f3a28e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3a28e6",
  null
  
)

export default component.exports